import { Card, Tree } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type CtsModuleSettingDataFragment } from '../../../../../api/fragments/CtsModuleSettingData';
import { type CtsModuleSpecsFragment } from '../../../../../api/fragments/CtsModuleSpecs';
import NoItemResult from '../../../../../components/results/NoItemResult';
import useTranslatedString from '../../../../../utilities/useTranslatedString';

type CtsSettingTabFinanceProductProps = {
    module: CtsModuleSpecsFragment;
    setting: CtsModuleSettingDataFragment;
};

const CtsSettingTabFinanceProduct = ({ module, setting }: CtsSettingTabFinanceProductProps) => {
    const { t } = useTranslation(['ctsModuleDetails']);
    const translatedString = useTranslatedString();

    const treeData = useMemo(
        () =>
            setting.financeProducts.map(financeProduct => ({
                key: financeProduct.id,
                title: translatedString(financeProduct.legalName),
            })),
        [setting.financeProducts, translatedString]
    );

    if (treeData.length === 0) {
        return <NoItemResult subTitle={t('ctsModuleDetails:tabs.financeProducts.noData')} />;
    }

    return (
        <Card>
            <Tree selectable={false} treeData={treeData} defaultExpandAll />
        </Card>
    );
};

export default CtsSettingTabFinanceProduct;
